module.exports = __webpack_public_path__ + "img/ES.fed7d0ce.png";